/* eslint-disable */
import React, {useRef, useState} from 'react';
import {
  Alert,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import Google from '../../assets/Google.svg';
import AppleLogo from '../../assets/icons/apple.svg';
import MailIcon from '../../assets/icons/mail.svg';
import PompiLogo from '../../assets/PompiImage.svg';
import AuthButton from '../../components/AuthButton';
import AuthBackdrop from '../../components/AuthBackdrop';
import InAppWebView from '../../components/InAppWebView';
import {WEB_PAGES} from '../../config/webPages';
import {colors, fonts, radii} from '../../config/theme';
import {useDispatch, useSelector} from 'react-redux';
import {googleLogin, appleLogin} from '../../slice/loginSlice';
import Toast from 'react-native-toast-message';
import appleAuth from '@invertase/react-native-apple-authentication';
import {Trans, useTranslation} from 'react-i18next';

const Login = ({navigation}) => {
  console.log('hi there');
  const dispatch = useDispatch();
  const {isLoading, error} = useSelector(state => state.login);
  const {t} = useTranslation();
  // Terms / Privacy page open in the in-app viewer: {title, url} or null
  const [webPage, setWebPage] = useState(null);

  const handleAppleLogin = async () => {
    try {
      const appleAuthRequestResponse = await appleAuth.performRequest({
        requestedOperation: appleAuth.Operation.LOGIN,
        requestedScopes: [appleAuth.Scope.FULL_NAME, appleAuth.Scope.EMAIL],
      });
      console.log('appleAuthRequestResponse', appleAuthRequestResponse);
      const {identityToken, fullName, user, email} = appleAuthRequestResponse;

      if (!identityToken) {
        console.error('No identity token received');
        return Alert.alert('Error', 'No identity token returned from Apple');
      }
      const credentialState = await appleAuth.getCredentialStateForUser(user);
      console.log('credentialState', credentialState);

      let name;
      if (fullName?.givenName || fullName?.familyName) {
        name = `${fullName?.givenName ?? ''} ${
          fullName?.familyName ?? ''
        }`.trim();
      }

      const payload = {
        socialId: user,
        name: name || 'Apple User',
        email: email,
      };
      console.log('payload', payload);

      const result = await dispatch(appleLogin(payload)).unwrap();
      Toast.show({
        type: 'success',
        text1: t(`root.Toast.Success.LoginSuccess`),
      });
      // setIsGoogleLoading(true);
      // const loginResponse = await AuthService.appleLogin(payload);
      // console.log('loginResponse', JSON.stringify(loginResponse));
      // if (loginResponse.isSuccess) {
      //   console.log('loginResponse isSuccess', loginResponse.isSuccess);
      //   changeRefreshCounter();
      //   updateUserState(loginResponse?.data);
      //   // try {
      //   //   await EncryptedStorage.setItem(
      //   //     'USERINFO',
      //   //     JSON.stringify(loginResponse?.data),
      //   //   );
      //   // } catch (storageError) {
      //   //   console.error('Failed to persist USERINFO after Apple iOS login:', storageError);
      //   // }
      //   const phoneVerified = loginResponse?.data?.user?.isPhoneVerified;
      //   if (!phoneVerified) {
      //     setCurrentScreen('phoneVerification');
      //   } else {
      //     bottomSheetRef?.current.close();
      //   }
      //   setIsGoogleLoading(false);
      //   Toast.show({
      //     type: 'successToast',
      //     props: {
      //       msg: 'Login Successful',
      //     },
      //   });
      //   setTimeout(async () => {
      //     const userDetailsString = await EncryptedStorage.getItem('USERINFO');
      //     const userDetails = JSON.parse(userDetailsString);
      //     navigate('BottomTab', userDetails);
      //   }, 1000);
      // } else {
      //   console.log('loginResponse else', JSON.stringify(loginResponse));
      //   setIsGoogleLoading(false);
      //   Alert.alert(
      //     'Login Failed',
      //     loginResponse.message || 'Please try again',
      //   );
      // }
    } catch (error) {
      // Error code 1000 means the user canceled the sign-in
      if (error?.code === '1000') {
        console.log('Apple Sign-In was canceled by the user');
        return; // Just return silently, no need to show an error
      }

      // For other errors, log and show an alert
      console.log('Apple Sign-In error:', JSON.stringify(error));
      console.error('Error during Apple Sign-In request:', error);
      Toast.show({
        type: 'error',
        text1:
          typeof error === 'string'
            ? error
            : error?.message || t(`root.Toast.Error.LoginFailed`),
      });
    }
  };
  const loginOptions = [
    ...(Platform.OS === 'ios'
      ? [
          {
            icon: <AppleLogo width={20} height={20} color={colors.onPrimary} />,
            name: 'Apple',
            variant: 'dark',
            onPress: async () => {
              await handleAppleLogin();
            },
          },
        ]
      : []),
    {
      icon: <Google width={20} height={20} />,
      name: 'Google',
      variant: 'light',
      onPress: async () => {
        await handleLogin();
      },
    },
  ];

  // Google allows ONE sign-in at a time. A second tap (or a second call while
  // the Google sheet is still open) makes the first one never finish, and
  // every later try then fails with "signIn already in progress".
  const lastGoogleTap = useRef(0);

  const handleLogin = async () => {
    const now = Date.now();
    if (now - lastGoogleTap.current < 3000) {
      return; // a sign-in was just started: ignore the extra tap
    }
    lastGoogleTap.current = now;
    try {
      const result = await dispatch(googleLogin()).unwrap();
      Toast.show({
        type: 'success',
        text1: t(`root.Toast.Success.LoginSuccess`),
      });
    } catch (err) {
      console.log('handleLogin error', err);
      const text = typeof err === 'string' ? err : err?.message || '';
      // Not a failure the user can fix: the Google sheet is already open.
      if (/in progress/i.test(text) || /cancel/i.test(text)) {
        return;
      }
      Toast.show({
        type: 'error',
        text1: err || t(`root.Toast.Error.LoginFailed`),
      });
    }
  };

  const insets = useSafeAreaInsets();

  return (
    <View style={styles.screen}>
      <AuthBackdrop />
      <ScrollView
        style={styles.flex}
        contentContainerStyle={[
          styles.scrollContent,
          {paddingTop: insets.top + 12, paddingBottom: insets.bottom + 16},
        ]}
        showsVerticalScrollIndicator={false}>
        <View style={styles.header}>
          <View style={styles.eyebrow}>
            <Text style={styles.eyebrowText}>{t(`root.Login.welcomeBack`)}</Text>
          </View>
        </View>

        <View style={styles.hero}>
          <PompiLogo width={240} height={229} />
          <Text style={styles.tagline}>{t(`root.Login.tagline`)}</Text>
        </View>

        <View style={styles.actions}>
          {loginOptions.map(option => (
            <AuthButton
              key={option.name}
              variant={option.variant}
              icon={option.icon}
              title={`${t(`root.Login.ContinueWith`)} ${option.name}`}
              onPress={option.onPress}
            />
          ))}
          <View style={styles.orContainer}>
            <View style={styles.line} />
            <Text style={styles.orText}>{t(`root.Login.or`)}</Text>
            <View style={styles.line} />
          </View>
          <AuthButton
            variant="gradient"
            icon={
              <MailIcon
                width={20}
                height={20}
                color={colors.onPrimary}
                style={styles.mailIcon}
              />
            }
            title={t(`root.Login.ContinueWithEmail`)}
            onPress={() => {
              navigation.navigate('LoginEmail');
            }}
          />
          <Text style={styles.legal}>
            <Trans
              i18nKey="root.Login.legal"
              components={{
                terms: (
                  <Text
                    style={styles.legalLink}
                    accessibilityRole="link"
                    onPress={() =>
                      setWebPage({
                        title: t('root.ProfileList.TermsAndConditions'),
                        url: WEB_PAGES.terms,
                      })
                    }
                  />
                ),
                privacy: (
                  <Text
                    style={styles.legalLink}
                    accessibilityRole="link"
                    onPress={() =>
                      setWebPage({
                        title: t('root.ProfileList.privacyPolicy', 'Privacy Policy'),
                        url: WEB_PAGES.privacy,
                      })
                    }
                  />
                ),
              }}
            />
          </Text>
        </View>
      </ScrollView>
      <InAppWebView
        visible={!!webPage}
        title={webPage?.title}
        url={webPage?.url}
        onClose={() => setWebPage(null)}
      />
    </View>
  );
};

const SIDE = 24;

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: colors.background,
  },
  flex: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
  },
  header: {
    height: 40,
    paddingHorizontal: SIDE,
    alignItems: 'center',
    justifyContent: 'center',
  },
  eyebrow: {
    paddingHorizontal: 14,
    paddingVertical: 4,
    borderRadius: radii.pill,
    backgroundColor: colors.mintWash,
    borderWidth: 1,
    borderColor: colors.mintLine,
  },
  eyebrowText: {
    fontFamily: fonts.semiBold,
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    color: colors.brandMid,
    opacity: 0.8,
  },
  hero: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: SIDE,
    paddingTop: 12,
    paddingBottom: 24,
  },
  tagline: {
    fontFamily: fonts.medium,
    fontSize: 14,
    lineHeight: 20,
    color: colors.textMuted,
    textAlign: 'center',
    // PompiImage.svg has ~37pt of transparent padding under the wordmark.
    marginTop: -28,
  },
  actions: {
    paddingHorizontal: SIDE,
    gap: 12,
  },
  orContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
  },
  line: {
    flex: 1,
    height: 1,
    backgroundColor: colors.border,
  },
  orText: {
    fontFamily: fonts.semiBold,
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    color: colors.textSubtle,
    paddingHorizontal: 12,
  },
  mailIcon: {
    opacity: 0.9,
  },
  legal: {
    marginTop: 8,
    fontFamily: fonts.regular,
    fontSize: 11,
    lineHeight: 18,
    color: colors.textSubtle,
    textAlign: 'center',
  },
  legalLink: {
    fontFamily: fonts.medium,
    color: colors.brandLink,
    textDecorationLine: 'underline',
  },
});

export default Login;